import React from 'react';

interface GoalsConfidenceIndicatorProps {
  score: number; // 1-5
  level: string;
  compact?: boolean;
  showLabel?: boolean;
}

export function GoalsConfidenceIndicator({
  score,
  level,
  compact = false,
  showLabel = false,
}: GoalsConfidenceIndicatorProps) {
  // Convert score to stars (1-5)
  const stars = Math.min(5, Math.max(1, Math.round(score)));

  // Get color based on level
  const getColor = () => {
    switch (level) {
      case 'high':
        return 'var(--goals-confidence-high, #22c55e)';
      case 'moderate':
        return 'var(--goals-confidence-moderate, #84cc16)';
      case 'low':
        return 'var(--goals-confidence-low, #f59e0b)';
      case 'speculative':
        return 'var(--goals-confidence-speculative, #ef4444)';
      default:
        return 'var(--goals-confidence-moderate, #84cc16)';
    }
  };

  const color = getColor();

  if (compact) {
    return (
      <div className="goals-confidence-compact">
        <div className="goals-confidence-dots">
          {[1, 2, 3, 4, 5].map((i) => (
            <span
              key={i}
              className="goals-confidence-dot"
              style={{
                backgroundColor: i <= stars ? color : 'var(--color-border, #e5e7eb)',
              }}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="goals-confidence-indicator">
      <div className="goals-confidence-stars">
        {[1, 2, 3, 4, 5].map((i) => (
          <svg
            key={i}
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill={i <= stars ? color : 'none'}
            stroke={color}
            strokeWidth="2"
            className="goals-confidence-star"
          >
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
          </svg>
        ))}
      </div>
      {showLabel && (
        <span className="goals-confidence-label" style={{ color }}>
          {level.charAt(0).toUpperCase() + level.slice(1)}
        </span>
      )}
    </div>
  );
}

export default GoalsConfidenceIndicator;
